import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMonth'
})
export class FilterMonthPipe implements PipeTransform {

  transform(events: any[], month: string | null | undefined): any[] {
    if (!events || !month) {
      return events;
    } else {
      return events.filter(event => {
        return event.dates.find((c: any) => c.split("-")[1] == month) != undefined;
      });
    }
  }
}
